var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26694(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26694",
    "data-name": "Group 26694",
    transform: "translate(-608 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(608 788)",
    fill: "#e03093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23252",
    "data-name": "Path 23252",
    d: "M496.545,78.575a1.8,1.8,0,0,1-1.176,1.694l-20.716,7.416a4.606,4.606,0,0,1-3.108,0l-13.967-5a7.791,7.791,0,0,0-1.828,3.446,2.3,2.3,0,0,1,.932,1.823,2.41,2.41,0,0,1-.874,1.786l1.819,10.919a1.171,1.171,0,0,1-1.156,1.365H452.2a1.173,1.173,0,0,1-1.157-1.366l1.82-10.919a2.306,2.306,0,0,1-.875-1.785,2.346,2.346,0,0,1,1.431-2.158,10.119,10.119,0,0,1,1.8-3.954l-4.4-1.576a1.806,1.806,0,0,1,0-3.385l20.66-7.416a4.606,4.606,0,0,1,3.108,0l20.716,7.416a1.768,1.768,0,0,1,1.238,1.693m-10.462,7.507,1.082,10.472c0,3.024-6.368,5.471-14.07,5.471-7.833,0-14.07-2.447-14.07-5.474l1.085-10.464,10.639,3.806a6.927,6.927,0,0,0,2.345.407,6.294,6.294,0,0,0,2.279-.41Z",
    transform: "translate(171.354 738.804)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26694);
export default __webpack_public_path__ + "static/media/Group 26694.f4b8e39f34438066f9e2adba11402646.svg";
export { ForwardRef as ReactComponent };